module.exports = __webpack_public_path__ + "images/9d672db9d4ee64fff96100e4cbafb018.jpg";